import { Paper, Typography } from "@mui/material";
import { RouteComponentProps } from "react-router-dom";
import { CreateIntegrationForm } from "./CreateIntegrationForm";

export default function CreateIntegrationPage(props: RouteComponentProps) {
  return (
    <Paper sx={{ padding: "1em" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Ny integrasjon</Typography>
      <CreateIntegrationForm />
    </Paper>
  );
}
